import { Modal, useModals } from 'almanac-ui/Modal'
import { ContentTypeCardSwitch } from 'screens/blaze/Home/components/Catalogue/components/ContentTypeCard/ContentTypeCardSwitch'
import { Carousel } from 'components/Carousel/Carousel'
import { AspectRatioKey } from 'components/NewFileModal/Types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { GoToBrandsButton } from 'components/BrandWizardNewDesignModal/GoToBrandsButton'
import { Search } from 'components/BrandWizardNewDesignModal/Search'
import Styles from './CreateContentModal.module.scss'
import { HighDetailedVoice } from 'blaze-ui/icons/24'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useGroups } from 'components/Wizards/Catalogue/useGroups'
import { TextChannelKey, TurnInto } from 'types'
import { filterGroups } from 'components/Wizards/Catalogue/useGroups'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Button } from 'blaze-ui/Button'

const hiddenKeys = new Set<TextChannelKey>([
  ...Object.values(TurnInto),
  GenerationType.Campaign,
  GenerationType.Brainstorm,
])

export const CreateContentModal = ({ voiceId }: { voiceId: number }) => {
  const workspaceId = useCurrentWorkspaceId()
  const groups = useGroups()
  const { isMobile } = useResponsiveDesign()
  const { closeAllModals } = useModals()

  const filteredGroups = filterGroups(
    hiddenKeys,
    groups.filter((group) => group.name === 'Tools'),
  )

  return (
    <Modal.Root blaze bodyClassName={Styles.modal}>
      <Modal.Header
        className={Styles.header}
        title={!isMobile ? 'Put your new Brand Voice to work' : 'Brand Voice Created!'}
        actions={
          !isMobile ? (
            <GoToBrandsButton workspaceId={workspaceId} />
          ) : (
            <Button variant="ghost" onPress={() => closeAllModals()}>
              Skip
            </Button>
          )
        }
      />
      <div className={Styles.searchContainer}>
        {!isMobile && <HighDetailedVoice size={40} />}
        <Heading level={isMobile ? 5 : 4}>
          {isMobile ? 'Put your new Brand Style to work' : 'Choose a content type'}
        </Heading>
        <div className={Styles.searchWrapper}>
          <Search initialValues={{ brand_voice_id: voiceId }} groups={groups} />
        </div>
      </div>
      <div className={Styles.carouselContainer}>
        {!isMobile && <Heading level={4}>Generate a full month of content in minutes in your Brand Voice</Heading>}
        <Carousel buttonSize="sm">
          {filteredGroups.flatMap((group) => {
            return group.channels.map((channel) => {
              return (
                <ContentTypeCardSwitch
                  key={channel}
                  channel={channel as AspectRatioKey}
                  initialValues={{ brand_voice_id: voiceId }}
                />
              )
            })
          })}
        </Carousel>
      </div>
    </Modal.Root>
  )
}
